import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ProjectDashboard } from './components/ProjectDashboard';

export default function Workflows() {
    const navigate = useNavigate();
    const location = useLocation();
    const basePath = '/dashboard/workflows';

    // Memoize subRoute calculation (include search params for filter preservation)
    const subRoute = React.useMemo(() => {
        const pathname = location.pathname === basePath || location.pathname === `${basePath}/`
            ? ''
            : location.pathname.replace(basePath, '');
        // Include search params so filters/query params are preserved
        return pathname + location.search;
    }, [location.pathname, location.search]);

    // Memoize route change handler
    const handleRouteChange = React.useCallback((newRoute: string) => {
        const nextUrl = `${basePath}${newRoute}`;
        if (nextUrl !== location.pathname) {
            navigate(nextUrl);
        }
    }, [navigate, location.pathname, basePath]);

    return (
        <div className="h-full w-full flex flex-col">
            <ProjectDashboard
                subRoute={subRoute}
                onRouteChange={handleRouteChange}
            />
        </div>
    );
}